import React, { useEffect } from 'react';
import "../styles/heroSectionSecondary.css";

export default function HeroSectionSecondary({
  title,
  subtitle,
  button1Text,
  button1Link,
  button2Text,
  button2Link,
  image,
}) {
  // Preload the hero image for faster loading
  useEffect(() => {
    if (image) {
      const img = new Image();
      img.src = process.env.PUBLIC_URL + image;
    }
  }, [image]);
  return (
    <section
      className="hero-section text-center hero-static"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="secondary-hero-static-overlay">
        <div className="logo-line">
          <h1 className="secondary-hero-title">{title}</h1>
        </div>
        {subtitle && <p className="secondary-hero-subheading">{subtitle}</p>}

        <div className="mt-4">
          {button1Text && (
            <a href={button1Link || '#'} className="btn-cta" style={{ textTransform: 'uppercase' }}>
              {button1Text}
            </a>
          )}
          {button2Text && (
            <a
              href={button2Link || '#'}
              className="btn-primary"
              style={{ textTransform: 'uppercase', marginLeft: '1rem' }}
            >
              {button2Text}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
